module.exports = __webpack_public_path__ + "static/img/empty.de57fd6e.png";